import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import { CommonModule } from '@angular/common';
import {QrCodeAssociationService} from "./qr-code-association.service";
import {QrCodeComponent} from "../../../shared/qr-code/qr-code.component";
import {NzFormModule} from "ng-zorro-antd/form";
import {filter, tap} from "rxjs/operators";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'app-qr-code-association',
  standalone: true,
  imports: [CommonModule, QrCodeComponent, NzFormModule],
  templateUrl: './qr-code-association.component.html',
  styleUrls: ['./qr-code-association.component.sass'],
  providers: [QrCodeAssociationService]
})
export class QrCodeAssociationComponent implements OnInit{
  @Input() description: string | TemplateRef<any>;
  @Output() onSyncronizeWithApp = new EventEmitter<boolean>(false);

  readonly qrCode$ = this.qrCodeAssociationService.qrCode$;


  constructor(
    private qrCodeAssociationService: QrCodeAssociationService
  ) {
    this.qrCodeAssociationService.createQrCode();
  }

  isString(value: string | TemplateRef<any>): boolean {
    return typeof value === 'string';
  }

  $TemplateRef = (template: TemplateRef<any>) => template;

  ngOnInit(): void {
    this.qrCodeAssociationService.deviceAssociated$.pipe(
      untilDestroyed(this),
      filter(value => value),
      tap(isDeviceAssociated => this.onSyncronizeWithApp.emit(isDeviceAssociated))
    ).subscribe();
  }
}
